import {ValueObject} from '@s-ui/domain'

export class GroupedVersionSpecificationsValueObject extends ValueObject {
  /**
   * @param {VersionSpecificationsValueObject} params.body
   * @param {VersionSpecificationsValueObject} params.consumption
   * @param {VersionSpecificationsValueObject} params.cycle
   * @param {VersionSpecificationsValueObject} params.engine
   * */
}
